import { MongoClient } from "mongodb";
export class FuseInitializerMongo {
    constructor(inits) {
        Object.defineProperty(this, "_mongoClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_inits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._inits = inits;
        this._mongoClient = new MongoClient(inits.uri, inits.options);
    }
    async getInstance() {
        if (!this._mongoClient) {
            this._mongoClient = new MongoClient(this._inits.uri, this._inits.options);
        }
        if (!this._mongoClient.isConnected()) {
            await this._mongoClient.connect();
        }
        return this._mongoClient;
    }
    async getDbInstance() {
        const client = await this.getInstance();
        const database = client.db(this._inits.databaseName);
        const collection = database.collection(this._inits.collectionName);
        return collection;
    }
    async close() {
        if (this._mongoClient) {
            await this._mongoClient.close();
        }
    }
}
